// this code is for open reviews of product when user click in opinions.
export const openOpinionsAccordion = () => {
  let cont=0;
  const opinionsListener=$( '#conversion-zone' ).find( '.product-notation a' );
  $(opinionsListener[0]).click(() => {
    
    getOpinionsDiv(cont);
    cont =1;
  });
};

function getOpinionsDiv(cont){
  if(cont >0){
    expandOpinions();
  } else {
    setTimeout(() => {
      expandOpinions();
    },1000);
  }
}
function expandOpinions(){
  const isReviewExpanded = document.getElementById('collapse-review').getAttribute('aria-expanded');
  if(isReviewExpanded === 'false'){
    window.$('#ReviewsFloor .floor-collapse header').click();
  }
}


// WEBPACK FOOTER //
// ./src/_override/shared/pdp/open-opinions/open-opinions.js